import { useCallback, useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  Icon,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./EditUserLimits.module.css";
import config from "../../../config/config";
import axios from "axios";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../../useDebouncedLog";
import { observer } from "mobx-react";
import { verifyTokenAccess } from "../../../Helper";

const EditUserLimits = observer(
  ({ isVisible, onClose, openNoti, className = "" }) => {
    const [Txnlimt, setTxnlimt] = useState("");
    const [dailyLimit, setDailyLimit] = useState("");
    const [MonthlyLimit, setMonthlyLimit] = useState("");
    const [oldRoles, setOldRoles] = useState([]);
    const [adminEnabled, setAdminEnabled] = useState(false);
    const [ownerEnabled, setOwnerEnabled] = useState(false);
    const [ownerDisabled, setOwnerDisabled] = useState(false);
    const [wasOwner, setWasOwner] = useState(false);
    const [userEnabled, setUserEnabled] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [AllTags, setAllTags] = useState([]);
    const [isViewAdmin, setIsViewAdmin] = useState(false);
    const [ShowOwnerPopUp, setShowOwnerPopUp] = useState(false);
    const [add_remove_owner, setAdd_remove_owner] = useState(false);
    const [ShowOwnerPopUpConfirm, setShowOwnerPopUpConfirm] = useState(false);
    const [removeOwner, setRemoveOwner] = useState(false)
    const [errormsg, setErrorMsg] = useState({
      isAnyFieldEmpty: false,
      isTxnLimitNegative: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
      somethingWentWrong: false,
    });
    const [copied, setCopied] = useState(false);
    const [disabledLimits, setdisabledLimits] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [ownerAddedSuccess, setOwnerAddedSuccess] = useState(false);
    // ────────────────────────────────────────────────
    // KYC PENDING / INCOMPLETE FLAG
    // ────────────────────────────────────────────────
    const isKycPendingOrIncomplete =
      companyStore.userType === "PineLabUser" &&
      !companyStore.UserHasWallet &&
      (!companyStore?.userKycInfo ||
        companyStore?.userKycInfo?.kyc_initiate_on ||
        ["kyc_initiated", "kyc_pending", "kyc_link_expired"].includes(
          companyStore?.userKycInfo?.initiate_kyc_bp_response?.status,
        ));

    var logEditUserVisited;
    var logEditUserInvoked;
    try {
      logEditUserVisited = useDebouncedLog("admin_edit_user_visited", 500);
      logEditUserInvoked = useDebouncedLog("admin_edit_user_Invoked", 500);
    } catch (err) {
      console.log("error", err);
    }

    useEffect(() => {
      logEditUserVisited();
      setAllTags(store.Tags.filter((tag) => tag !== ""));
      setTxnlimt(companyStore.txnLimit);
      setDailyLimit(companyStore.DailyLimit);
      setMonthlyLimit(companyStore.MonthlyLimit);

      // Only disable limits when KYC is in progress
      if (
        companyStore.userType == "PineLabUser" &&
        !companyStore.UserHasWallet &&
        companyStore.userKycInfo
      ) {
        const kycStatus =
          companyStore?.userKycInfo?.initiate_kyc_bp_response?.status;
        if (
          companyStore?.userKycInfo?.kyc_initiate_on &&
          (kycStatus === "kyc_initiated" || kycStatus === "kyc_link_expired")
        ) {
          setdisabledLimits(true);
        } else {
          setdisabledLimits(false);
        }
      }
    }, [logEditUserVisited]);

    // Force clear Owner + App User when KYC is still pending
    // useEffect(() => {
    //   if (isKycPendingOrIncomplete) {
    //     // setOwnerEnabled(false);
    //  setUserEnabled(false); // ← important: clear App User
    //   }
    // }, [isKycPendingOrIncomplete]);

    useEffect(() => {
      if (store.UserRoles.includes("OWNER")) {
        // Do NOT grant Owner while KYC is pending

        setOwnerEnabled(true);
        setWasOwner(true);
        setAdminEnabled(true);
        setIsViewAdmin(true);
        if (!oldRoles.includes("OWNER")) {
          oldRoles.push("OWNER");
        }
      }
      if (store.UserRoles.includes("ADMIN")) {
        setAdminEnabled(true);
        if (!oldRoles.includes("ADMIN")) {
          oldRoles.push("ADMIN");
        }
        // console.log("====>Admin");
      }
      if (companyStore?.userKycInfo?.kyc_initiate_on) {
        console.log("companyStore?.userKycInfo", Object.keys(companyStore?.userKycInfo));
        console.log("companyStore?.userKycInfo->>", companyStore?.userKycInfo?.initiate_kyc_bp_response?.status);

      }
      if (companyStore?.userKycInfo?.initiate_kyc_bp_response?.status == "kyc_initiated") {
        setUserEnabled(true);
      }
      if (companyStore?.userKycInfo?.initiate_kyc_bp_response?.status == "kyc_link_expired") {
        setUserEnabled(true);
      }
      if (store.UserRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
        // Do NOT grant App User while KYC is pending
        // if (!isKycPendingOrIncomplete) {
        setUserEnabled(true);
        if (!oldRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
          oldRoles.push("CUPI_COMPANY_EMPLOYEE");
          //}
        }
      }
      if (store.UserRoles.includes("CUPI_VIEW_ADMIN")) {
        setIsViewAdmin(true);
        if (!oldRoles.includes("CUPI_VIEW_ADMIN")) {
          oldRoles.push("CUPI_VIEW_ADMIN");
        }
      }
      if (store.UserRoles.length == 0) {
        setOwnerEnabled(false);
        setAdminEnabled(false);
        setUserEnabled(false);
      }
    }, []);

    const getLoggedInPhone = () => {
      try {
        const tokens = localStorage.getItem("authToken");
        verifyTokenAccess("Edit user Limit getLoggedInPhone")
        if (!tokens) return "";

        const parsed = JSON.parse(tokens);
        const decoded = jwtDecode(parsed.IdToken);

        return decoded.phone_number || decoded["cognito:username"] || "";
      } catch (err) {
        console.log("Error getting logged in phone:", err);
        return "";
      }
    };
    const loggedInPhone = getLoggedInPhone();
    {
      // console.log("Logged in phone →", loggedInPhone);
    }

    const isTokenExpired = (token) => {
      try {
        const decoded = jwtDecode(token);

        if (decoded && decoded.exp) {
          const currentTime = Math.floor(Date.now() / 1000);
          return decoded.exp < currentTime;
        }
      } catch (error) {
        console.log("Error decoding token:", error);
        return true;
      }
      return true;
    };

    const getNewTokens = async (authData) => {
      if (!authData?.RefreshToken) {
        localStorage.removeItem("authToken");
        navigate("/login");
        return;
      }

      try {
        const client = new CognitoIdentityProviderClient({
          region: "ap-south-1",
        });

        const params = {
          ClientId: config.Client_Id,
          AuthFlow: "REFRESH_TOKEN_AUTH",
          AuthParameters: {
            REFRESH_TOKEN: authData?.RefreshToken,
          },
        };

        const command = new InitiateAuthCommand(params);
        const refreshResponse = await client.send(command);

        if (refreshResponse.AuthenticationResult) {
          const newAuthToken = {
            AccessToken: refreshResponse.AuthenticationResult.AccessToken,
            RefreshToken: authData?.RefreshToken,
            IdToken: refreshResponse.AuthenticationResult.IdToken,
          };

          localStorage.setItem("authToken", JSON.stringify(newAuthToken));
          if (store.refresh) {
            store.setRefresh(false);
          } else {
            store.setRefresh(true);
          }
        } else {
          localStorage.removeItem("authToken");
          navigate("/login");
        }
      } catch (error) {
        console.log("Error refreshing tokens:", error);
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    };

    const onFrameButtonClick = () => {
      try {
        setRemoveOwner(false)
        logEditUserInvoked();
      } catch (err) {
        console.log("error", err);
      }
      setErrorMsg({
        isAnyFieldEmpty: false,
        isTxnLimitNegative: false,
        isDailyLimitNegative: false,
        isMonthlyLimitNegative: false,
        isTxnLimitExceeds: false,
        isDailyLimitExceedsMonthly: false,
      });
      if (
        (Txnlimt == "" || dailyLimit == "" || MonthlyLimit == "") &&
        userEnabled
      ) {
        console.log("error");

        setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
        setErrorMessage("All Fields are required");
        return;
      }
      if (
        userEnabled &&
        (Number(dailyLimit) <= 0 ||
          Number(Txnlimt) <= 0 ||
          Number(MonthlyLimit) <= 0)
      ) {
        if (Number(dailyLimit) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
        }
        if (Number(Txnlimt) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
        }
        if (Number(MonthlyLimit) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
        }
        setErrorMessage("Limits Cannot be 0");
        return;
      }
      if (
        Number(Txnlimt) > Number(dailyLimit) ||
        Number(Txnlimt) > Number(MonthlyLimit)
      ) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
        setErrorMessage(
          "Transaction Limit should not be greater than dailyLimit or monthlyLimit",
        );
        return;
      }
      if (Number(dailyLimit) > Number(MonthlyLimit)) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
        setErrorMessage("Daily Limit should not be greater than monthlyLimit");
        return;
      }
      let tokens = localStorage.getItem("authToken");
      verifyTokenAccess("Edit user Limit Frame Click")
      let parsedTokens = JSON.parse(tokens);
      try {
        const expired = isTokenExpired(parsedTokens.IdToken);
        if (expired) {
          parsedTokens = getNewTokens(parsedTokens);
        }
      } catch (er) {
        console.log("error", er);
      }

      let newRoles = [];

      // Never allow OWNER or App User while KYC is pending
      if (ownerEnabled) {
        newRoles.push("OWNER");
      }
      if (adminEnabled) {
        newRoles.push("ADMIN");
        newRoles.push("CUPI_VIEW_ADMIN");
      }
      // if (userEnabled && !isKycPendingOrIncomplete)
      if (userEnabled && !isKycPendingOrIncomplete) {
        // if (companyStore.userType != "PineLabUser") {
        //   newRoles.push("CUPI_COMPANY_EMPLOYEE");
        // } else if (companyStore.UserHasWallet) {
        //   newRoles.push("CUPI_COMPANY_EMPLOYEE");
        // } else if (
        //   !companyStore.UserHasWallet &&
        //   !companyStore?.userKycInfo?.kyc_initiate_on
        // ) {
        newRoles.push("CUPI_COMPANY_EMPLOYEE");
      }
      //}
      if (isViewAdmin && !newRoles.includes("CUPI_VIEW_ADMIN")) {
        newRoles.push("CUPI_VIEW_ADMIN");
      }

      // ─── Detect if Owner was newly added ───
      const isOwnerNewlyAdded =
        newRoles.includes("OWNER") && !oldRoles.includes("OWNER");

      if (isOwnerNewlyAdded) {
        setOwnerAddedSuccess(true);
      } else {
        setOwnerAddedSuccess(false);
      }
      const isOwnerNewlyRemoved =
        !newRoles.includes("OWNER") && oldRoles.includes("OWNER");

      if (isOwnerNewlyRemoved) {
        setOwnerDisabled(true);
      } else {
        setOwnerDisabled(false);
      }

      const haveRolesChanged = (oldRoles, newRoles) => {
        if (oldRoles.length !== newRoles.length) return true;
        return (
          oldRoles.some((role) => !newRoles.includes(role)) ||
          newRoles.some((role) => !oldRoles.includes(role))
        );
      };

      const rolesChanged = haveRolesChanged(oldRoles, newRoles);
      console.log("isOwnerNewlyRemoved", isOwnerNewlyRemoved);
      // Prioritize owner message
      if (
        rolesChanged &&
        (Number(companyStore.txnLimit) != Number(Txnlimt) ||
          Number(companyStore.DailyLimit) != Number(dailyLimit) ||
          Number(companyStore.MonthlyLimit) != Number(MonthlyLimit))
      ) {
        setSuccessMessage(
          "The user transaction limits and roles have been updated",
        );
      } else if (
        Number(companyStore.txnLimit) != Number(Txnlimt) ||
        Number(companyStore.DailyLimit) != Number(dailyLimit) ||
        Number(companyStore.MonthlyLimit) != Number(MonthlyLimit)
      ) {
        setSuccessMessage(
          "The user transaction limits have been successfully updated",
        );
      } else if (rolesChanged) {
        setSuccessMessage("Role has been updated");
      } else {
        setSuccessMessage(
          "The user information have been successfully updated",
        );
      }

      if (isOwnerNewlyAdded) {
        if (
          Number(companyStore.txnLimit) != Number(Txnlimt) ||
          Number(companyStore.DailyLimit) != Number(dailyLimit) ||
          Number(companyStore.MonthlyLimit) != Number(MonthlyLimit)
        ) {
          setSuccessMessage(
            `${store.name.substring(0, 25)} has been added as Owner and transaction limits have been updated.`,
          );
        } else {
          setSuccessMessage(`${store.name.substring(0, 25)} has been added as owner.`);
        }
      } else if (isOwnerNewlyRemoved) {
        if (
          Number(companyStore.txnLimit) != Number(Txnlimt) ||
          Number(companyStore.DailyLimit) != Number(dailyLimit) ||
          Number(companyStore.MonthlyLimit) != Number(MonthlyLimit)
        ) {
          setSuccessMessage(
            `${store.name.substring(0, 25)} has been removed as Owner and transaction limits have been updated.`,
          );
        } else {
          setRemoveOwner(true)
          setSuccessMessage(`${store.name.substring(0, 25)} has been Removed as owner.`);
        }
      }

      const rolesToCheck = ["ADMIN", "OWNER", "CUPI_COMPANY_EMPLOYEE"];
      if (
        companyStore.userType == "PineLabUser" &&
        !companyStore.UserHasWallet &&
        !companyStore?.userKycInfo?.kyc_initiate_on &&
        newRoles.includes("CUPI_COMPANY_EMPLOYEE") &&
        !oldRoles.includes("CUPI_COMPANY_EMPLOYEE") &&
        ((newRoles.includes("ADMIN") &&
          !oldRoles.includes("ADMIN")) ||
          (newRoles.includes("CUPI_VIEW_ADMIN") &&
            !oldRoles.includes("CUPI_VIEW_ADMIN")) ||
          (newRoles.includes("OWNER") &&
            !oldRoles.includes("OWNER")))
      ) {
        let RolesBeforeAddingUser = newRoles.filter(item => item !== "CUPI_COMPANY_EMPLOYEE");
        let obj1;
        let phone = store.SelectedPhoneNo;
        if (store.selectedEmail.trim()) {
          obj1 = JSON.stringify({
            user_name: store.name.trim(),
            user_id: store.userId,
            create_at: store.create_at,
            user_email: store.selectedEmail.trim(),
            user_mobile_no: phone,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: RolesBeforeAddingUser,
            tags: AllTags.join(", "),
          });
        } else {
          obj1 = JSON.stringify({
            user_name: store.name.trim(),
            user_id: store.userId,
            create_at: store.create_at,
            user_mobile_no: phone,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: RolesBeforeAddingUser,
            tags: AllTags.join(", "),
          });
        }
        if (companyStore.TagsEmpDetails) {
          let newtags = JSON.parse(JSON.stringify(companyStore.TagsEmpDetails));

          let objtest = {
            employee_code: newtags.Empcode,
            employee_department: newtags.Department,
            employee_location: newtags.location,
          };
          obj1 = JSON.parse(obj1);
          obj1.employee_info = objtest;
          obj1 = JSON.stringify(obj1);
          let payload = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${config.node_api_endpoint}/cupi/admin/cupi_user_update_limit`,
            headers: {
              aws_cognito_id_token: parsedTokens?.IdToken,
              aws_cognito_access_token: parsedTokens?.AccessToken,
              "Content-Type": "application/json",
            },
            data: obj1,
          };
          axios
            .request(payload)
            .then(async (res) => {
              if (phone.startsWith("+91")) {
                phone = phone.slice(3);
              }
              if (store.selectedEmail.trim()) {
                obj1 = JSON.stringify({
                  user_name: store.name.trim(),
                  user_email: store.selectedEmail.trim(),
                  user_mobile_no: phone,
                  user_id: store.userId,
                  create_at: store.create_at,
                  perTxnLimit: Number(Txnlimt),
                  dailyLimit: Number(dailyLimit),
                  monthlyLimit: Number(MonthlyLimit),
                  ledger_label: store.Company_Id,
                  roles: newRoles,
                  tags: AllTags.join(", "),
                });
              } else {
                obj1 = JSON.stringify({
                  user_name: store.name.trim(),
                  user_mobile_no: phone,
                  user_id: store.userId,
                  create_at: store.create_at,
                  perTxnLimit: Number(Txnlimt),
                  dailyLimit: Number(dailyLimit),
                  monthlyLimit: Number(MonthlyLimit),
                  ledger_label: store.Company_Id,
                  roles: newRoles,
                  tags: AllTags.join(", "),
                });
              }
              let tokens = localStorage.getItem("authToken");
              let parsedTokens = JSON.parse(tokens);
              let payload = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${config.node_api_endpoint}/cupi/admin/pine/create_cupi_compnay_user`,
                headers: {
                  aws_cognito_id_token: parsedTokens?.IdToken,
                  aws_cognito_access_token: parsedTokens?.AccessToken,
                  "Content-Type": "application/json",
                },
                data: obj1,
              };
              try {
                axios
                  .request(payload)
                  .then(async (res) => {
                    let userExist;
                    setOldRoles(newRoles)
                    if (res.data.data) {
                      userExist =
                        res?.data?.data?.message == "User Already Exists :" ||
                        res?.data?.data == "User KYC is pending";
                    }
                    try {

                      store.setTxnLimit(Txnlimt);
                      store.setDailyLimit(dailyLimit);
                      store.setmonthlyLimit(MonthlyLimit);
                    } catch (err) {
                      console.log("error while resetting limits");

                    }
                    if (ownerEnabled) {
                      setWasOwner(true);
                    } else {
                      setWasOwner(false);
                    }
                    if (userExist) {
                      store.refresh
                        ? store.setRefresh(false)
                        : store.setRefresh(true);
                      setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
                      setErrorMessage("User Already Exists");
                      setOwnerAddedSuccess(false);
                      return;
                    }
                    setIsUpdated(true);
                    await new Promise((resolve) => setTimeout(resolve, 3000));
                    setIsUpdated(false);
                    setOwnerAddedSuccess(false);
                  })
                  .catch(async (err) => {
                    setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
                    setErrorMessage(
                      "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
                    );
                    setOwnerAddedSuccess(false);

                    await new Promise((resolve) => setTimeout(resolve, 3000));
                    setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
                    setErrorMessage("");
                  });
              } catch (err) {
                console.log(err);
              }
            })
            .catch(async (err) => {
              console.log(err);

              setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
              setErrorMessage(
                "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
              );
              setOwnerAddedSuccess(false);

              await new Promise((resolve) => setTimeout(resolve, 3000));
              setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
              setErrorMessage("");
            });
        }
      } else if (
        companyStore.userType == "PineLabUser" &&
        !companyStore.UserHasWallet &&
        !companyStore?.userKycInfo?.kyc_initiate_on &&
        newRoles.includes("CUPI_COMPANY_EMPLOYEE") &&
        !oldRoles.includes("CUPI_COMPANY_EMPLOYEE")
      ) {

        console.log("BLOCK!!!!!!!!!!!!!!!!!!!!");

        let obj1;
        let phone = store.SelectedPhoneNo;
        if (phone.startsWith("+91")) {
          phone = phone.slice(3);
        }
        if (store.selectedEmail.trim()) {
          obj1 = JSON.stringify({
            user_name: store.name.trim(),
            user_email: store.selectedEmail.trim(),
            user_mobile_no: phone,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newRoles,
            tags: AllTags.join(", "),
          });
        } else {
          obj1 = JSON.stringify({
            user_name: store.name.trim(),
            user_mobile_no: phone,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newRoles,
            tags: AllTags.join(", "),
          });
        }

        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        let payload = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${config.node_api_endpoint}/cupi/admin/pine/create_cupi_compnay_user`,
          headers: {
            aws_cognito_id_token: parsedTokens?.IdToken,
            aws_cognito_access_token: parsedTokens?.AccessToken,
            "Content-Type": "application/json",
          },
          data: obj1,
        };
        try {
          axios
            .request(payload)
            .then(async (res) => {
              let userExist;
              setOldRoles(newRoles)
              if (res.data.data) {
                userExist =
                  res?.data?.data?.message == "User Already Exists :" ||
                  res?.data?.data == "User KYC is pending";
              }
              try {

                store.setTxnLimit(Txnlimt);
                store.setDailyLimit(dailyLimit);
                store.setmonthlyLimit(MonthlyLimit);
              } catch (err) {
                console.log("error while resetting limits");

              }
              if (userExist) {
                store.refresh
                  ? store.setRefresh(false)
                  : store.setRefresh(true);
                setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
                setErrorMessage("User Already Exists");
                setOwnerAddedSuccess(false);
                return;
              }
              setIsUpdated(true);
              await new Promise((resolve) => setTimeout(resolve, 3000));
              setIsUpdated(false);
              setOwnerAddedSuccess(false);
            })
            .catch(async (err) => {
              setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
              setErrorMessage(
                "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
              );
              setOwnerAddedSuccess(false);

              await new Promise((resolve) => setTimeout(resolve, 3000));
              setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
              setErrorMessage("");
            });
        } catch (err) {
          console.log(err);
        }
      } else {
        let obj;
        if (newRoles.includes("CUPI_COMPANY_EMPLOYEE")) {
          obj = JSON.stringify({
            ledger_label: store.Company_Id,
            user_id: store.userId,
            create_at: store.create_at,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            roles: newRoles,
            tags: AllTags.join(", "),
          });
        } else {
          obj = JSON.stringify({
            ledger_label: store.Company_Id,
            user_id: store.userId,
            create_at: store.create_at,
            perTxnLimit: 0,
            dailyLimit: 0,
            monthlyLimit: 0,
            roles: newRoles,
            tags: AllTags.join(", "),
          });
        }
        console.log("Object Before upate", obj);
        if (!store.userId || store.userId == "NA") {
          obj = JSON.parse(obj)
          obj.mobile_no = store.SelectedPhoneNo
          obj = JSON.stringify(obj)

          store.setPhoneNo(`+91${store.SelectedPhoneNo.trim()}`)
        }
        if (companyStore.TagsEmpDetails) {
          let newtags = JSON.parse(JSON.stringify(companyStore.TagsEmpDetails));

          let objtest = {
            employee_code: newtags.Empcode,
            employee_department: newtags.Department,
            employee_location: newtags.location,
          };
          obj = JSON.parse(obj);
          obj.employee_info = objtest;
          obj = JSON.stringify(obj);
        }

        let payload = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${config.node_api_endpoint}/cupi/admin/cupi_user_update_limit`,
          headers: {
            aws_cognito_id_token: parsedTokens?.IdToken,
            aws_cognito_access_token: parsedTokens?.AccessToken,
            "Content-Type": "application/json",
          },
          data: obj,
        };

        axios
          .request(payload)
          .then(async (res) => {
            setOldRoles(newRoles);
            setIsUpdated(true);
            store.setTxnLimit(Number(Txnlimt));
            store.setDailyLimit(Number(dailyLimit));
            store.setmonthlyLimit(Number(MonthlyLimit));
            if (ownerEnabled) {
              setWasOwner(true);
            } else {
              setWasOwner(false);
            }
            store.refresh ? store.setRefresh(false) : store.setRefresh(true);
            await new Promise((resolve) => setTimeout(resolve, 3000));
            setIsUpdated(false);
            setOwnerAddedSuccess(false);
          })
          .catch(async (err) => {
            console.log(err);

            setErrorMsg((prev) => ({ ...prev, somethingWentWrong: true }));
            setErrorMessage(
              "We couldn’t update this user. Please try again. If the issue persists, contact CUPI Support",
            );
            setOwnerAddedSuccess(false);

            await new Promise((resolve) => setTimeout(resolve, 3000));
            setErrorMsg((prev) => ({ ...prev, somethingWentWrong: false }));
            setErrorMessage("");
          });
      }
    };

    const copyToClipboard = async (linkToCopy) => {
      try {
        setCopied(true);
        await navigator.clipboard.writeText(linkToCopy);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Failed to copy:", err);
        setCopied(false);
      }
    };

    const removeTag = (data, index) => {
      setAllTags((prevTags) => {
        const newTags = [...prevTags];
        newTags.splice(index, 1);
        return newTags;
      });
    };

    if (!isVisible) return null;
    return (
      <>
        <div
          className={styles.frameParent}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            className={styles.frameGroup}
            onClick={() => {
              store.refresh ? store.setRefresh(false) : store.setRefresh(true);
              onClose();
            }}
          >
            <img
              className={styles.arrowNarrowLeftIcon}
              alt=""
              src="/xclose.svg"
            />
          </div>
          <div className={styles.frameParent1}>
            <div className={styles.frameWrapperContainer}>
              <div className={styles.frameWrapper}>
                <div className={styles.mobileMenuParentHeading}>
                  Edit user details
                </div>

                <div className={styles.mobileMenuParent22}>
                  <div className={styles.mobileMenuContainer}>
                    <div className={styles.mobileMenuele1}>NAME</div>
                    <div className={styles.mobileMenuele2}>{store.name}</div>
                  </div>
                  <div className={styles.mobileMenuContainer}>
                    <div className={styles.mobileMenuele1}>USER PHONE NO</div>
                    <div className={styles.mobileMenuele2}>
                      {store.SelectedPhoneNo}
                    </div>
                  </div>
                  <div className={styles.mobileMenuContainer}>
                    <div className={styles.mobileMenuele1}>USER EMAIL ID</div>
                    <div className={styles.mobileMenuele2}>
                      {store.selectedEmail == "undefined"
                        ? "-"
                        : store.selectedEmail}
                    </div>
                  </div>
                  <div className={styles.mobileMenuContainer1}>
                    {store.TagsEmpDetails?.Empcode ||
                      store.TagsEmpDetails?.location ||
                      store.TagsEmpDetails?.Department ? (
                      <div className={styles.mobileMenuContainer2}>
                        <div className={styles.mobileMenueleContainer}>
                          <div className={styles.mobileMenuele1}>
                            USER EMPLOYEE DETAILS
                          </div>
                          {!disabledLimits &&
                            companyStore?.userKycInfo?.initiate_kyc_bp_response
                              ?.status != "kyc_link_expired" && (
                              <div
                                className={styles.mobileMenuelebtn}
                                onClick={() => {
                                  console.log(
                                    "store.TagsEmpDetails",
                                    store.TagsEmpDetails,
                                  );
                                  store.setShowEmpDetails(true);
                                }}
                              >
                                <img
                                  className={styles.arrowNarrowLeftIcon122}
                                  alt=""
                                  src="/edit-02.svg"
                                />
                              </div>
                            )}
                        </div>

                        <div className={styles.EmpinfoContentContainer}>
                          {store.TagsEmpDetails?.Empcode && (
                            <div className={styles.EmpinfoContent1}>
                              <img
                                className={styles.EmpinfoContenticon1}
                                alt=""
                                src="/user-square.svg"
                              />
                              {store.TagsEmpDetails?.Empcode.substring(0, 8)}
                            </div>
                          )}
                          {store.TagsEmpDetails?.location && (
                            <div className={styles.EmpinfoContent1}>
                              <img
                                className={styles.EmpinfoContenticon1}
                                alt=""
                                src="/location.svg"
                              />
                              {store.TagsEmpDetails.location.substring(0, 8)}
                            </div>
                          )}
                          {store.TagsEmpDetails?.Department && (
                            <div className={styles.EmpinfoContent1}>
                              <img
                                className={styles.EmpinfoContenticon1}
                                alt=""
                                src="/building-06.svg"
                              />
                              {store.TagsEmpDetails?.Department.substring(0, 8)}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className={styles.mobileMenuContainer111}>
                        {!disabledLimits &&
                          companyStore?.userKycInfo?.initiate_kyc_bp_response
                            ?.status != "kyc_link_expired" ? (
                          <button
                            className={styles.invertloadsButtons}
                            onClick={() => {
                              store.setShowEmpDetails(true);
                            }}
                          >
                            <img
                              className={styles.arrowNarrowLeftIcon1}
                              alt=""
                              src="/pluscircleBlue.svg"
                            />
                            <b>Add Employee Details</b>
                          </button>
                        ) : (
                          <button className={styles.invertloadsButtons}>
                            <img
                              className={styles.arrowNarrowLeftIcon1}
                              alt=""
                              src="/pluscircleBlue.svg"
                            />
                            <b>Add Employee Details</b>
                          </button>
                        )}
                      </div>
                    )}
                    <div className={styles.mobileMenuele1}>TAGS</div>
                    <div className={styles.setTransactionTagLimit}>
                      {AllTags.map((data, index) => {
                        let ShowTag = data;
                        if (data.includes(":")) {
                          const [key, value] = data.split(":");
                          ShowTag = value;
                        }
                        return (
                          <>
                            {data !== "" && (
                              <div className={styles.setTransactionOneTag}>
                                {ShowTag}
                              </div>
                            )}
                          </>
                        );
                      })}
                      {AllTags.length == 0 && (
                        <div className={styles.mobileMenuele2}>
                          No tags available.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.setTransactionLimitWrapper}>
                <div className={styles.addUserDetails}>
                  Set transaction limit
                </div>
              </div>
              <div className={styles.frameWrapper1}>
                <div className={styles.mobileMenuParent}>
                  <div className={styles.mobileMenu}>
                    <TextField
                      color="primary"
                      value={Txnlimt}
                      type="number"
                      required
                      disabled={
                        (!store.isUserOwner && adminEnabled) ||
                        (!store.isUserOwner && isViewAdmin) ||
                        disabledLimits
                      }
                      label="Per transaction limit"
                      onChange={(e) => {
                        setIsUpdated(false);
                        setErrorMessage("");
                        setErrorMsg((prev) => ({
                          ...prev,
                          isAnyFieldEmpty: false,
                          isTxnLimitNegative: false,
                          isTxnLimitExceeds: false,
                        }));

                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setTxnlimt(value);
                      }}
                      onWheel={(e) => e.target.blur()}
                      variant="outlined"
                      InputProps={{
                        style: {
                          borderRadius: ".75rem",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          appearance: "none",
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "100%",
                          maxHeight: "3.1rem",
                        },
                        width: "100%",
                        "& input[type=number]": {
                          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                          {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                        },
                      }}
                    />
                    {(errormsg.isTxnLimitNegative ||
                      errormsg.isTxnLimitExceeds) && (
                        <div className={styles.errorDiv}>
                          <div className={styles.error}>{ErrorMessage}</div>
                        </div>
                      )}
                    {errormsg.isAnyFieldEmpty && Txnlimt == "" && (
                      <div className={styles.errorDiv}>
                        <div className={styles.error}>{ErrorMessage}</div>
                      </div>
                    )}
                  </div>

                  <div className={styles.mobileMenu}>
                    <TextField
                      className={styles.mobileMenu}
                      color="primary"
                      value={dailyLimit}
                      type="number"
                      required
                      disabled={
                        (!store.isUserOwner && adminEnabled) ||
                        (!store.isUserOwner && isViewAdmin) ||
                        disabledLimits
                      }
                      label="Daily limit"
                      variant="outlined"
                      InputProps={{
                        style: {
                          borderRadius: ".75rem",
                          fontSize: "1rem",
                        },
                      }}
                      onChange={(e) => {
                        setErrorMessage("");
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setDailyLimit(value);
                        setIsUpdated(false);
                      }}
                      onWheel={(e) => e.target.blur()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "100%",
                          maxHeight: "3.1rem",
                        },
                        width: "100%",
                        "& input[type=number]": {
                          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                          {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                        },
                      }}
                    />

                    {(errormsg.isDailyLimitNegative ||
                      errormsg.isDailyLimitExceedsMonthly) && (
                        <div className={styles.errorDiv}>
                          <div className={styles.error}>{ErrorMessage}</div>
                        </div>
                      )}
                    {errormsg.isAnyFieldEmpty && dailyLimit == "" && (
                      <div className={styles.errorDiv}>
                        <div className={styles.error}>{ErrorMessage}</div>
                      </div>
                    )}
                  </div>

                  <div className={styles.mobileMenu}>
                    <TextField
                      className={styles.mobileMenu}
                      color="primary"
                      value={MonthlyLimit}
                      type="number"
                      required
                      disabled={
                        (!store.isUserOwner && adminEnabled) ||
                        (!store.isUserOwner && isViewAdmin) ||
                        disabledLimits
                      }
                      InputProps={{
                        style: {
                          borderRadius: ".75rem",
                        },
                      }}
                      onChange={(e) => {
                        setErrorMessage("");
                        setIsUpdated(false);
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setMonthlyLimit(value);
                      }}
                      onWheel={(e) => e.target.blur()}
                      label="Monthly limit"
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "100%",
                          maxHeight: "3.1rem",
                        },
                        width: "100%",
                        "& input[type=number]": {
                          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                          {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                        },
                      }}
                    />
                    {errormsg.isMonthlyLimitNegative && (
                      <div className={styles.errorDiv}>
                        <div className={styles.error}>{ErrorMessage}</div>
                      </div>
                    )}
                    {errormsg.isAnyFieldEmpty && MonthlyLimit == "" && (
                      <div className={styles.errorDiv}>
                        <div className={styles.error}>{ErrorMessage}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.RolesContainerMain}>
                  {((!adminEnabled && !isViewAdmin) ||
                    store.isUserOwner ||
                    store.isUserAdmin) && (
                      <div className={styles.AdminHeader}>Set Role*</div>
                    )}
                  <div className={styles.RolesContainer}>
                    {(store.isUserOwner || store.isUserAdmin) && (
                      <div
                        className={
                          ownerEnabled
                            ? styles.mobileMenuContainer12Dis
                            : styles.mobileMenuContainer12
                        }
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={adminEnabled}
                                // No KYC restriction – Admin can be given at any time
                                onChange={(event) => {
                                  if (!ownerEnabled) {
                                    setAdminEnabled(event.target.checked);
                                    setIsViewAdmin(event.target.checked);
                                  }
                                }}
                              />
                            }
                            label="Admin"
                          />
                        </FormGroup>
                      </div>
                    )}

                    {/* App User – blocked when KYC is pending */}
                    {((!adminEnabled && !isViewAdmin) ||
                      store.isUserOwner ||
                      store.isUserAdmin) && (
                        <div className={styles.mobileMenuContainer12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={userEnabled}
                                  disabled={
                                    isKycPendingOrIncomplete || disabledLimits
                                  }
                                  onChange={(event) =>
                                    setUserEnabled(event.target.checked)
                                  }
                                />
                              }
                              label="App User"
                            />
                          </FormGroup>
                        </div>
                      )}
                  </div>

                  {/* Owner – blocked when KYC is pending */}
                  {/* Owner – can be allocated at any time, independent of KYC status */}
                  {store.isUserOwner && (
                    <div
                      className={
                        ownerEnabled &&
                          String(store.SelectedPhoneNo).replace(/\D/g, "") ===
                          String(loggedInPhone).replace(/\D/g, "")
                          ? styles.mobileMenuContainer12Dis
                          : styles.mobileMenuContainer12
                      }
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={ownerEnabled}
                              disabled={
                                ownerEnabled &&
                                String(store.SelectedPhoneNo).replace(
                                  /\D/g,
                                  "",
                                ) === String(loggedInPhone).replace(/\D/g, "")
                              }
                              onChange={(event) => {
                                const checked = event.target.checked;

                                if (
                                  !checked &&
                                  String(store.SelectedPhoneNo).replace(
                                    /\D/g,
                                    "",
                                  ) === String(loggedInPhone).replace(/\D/g, "")
                                ) {
                                  return;
                                }

                                setAdd_remove_owner(checked);
                                setShowOwnerPopUp(true);
                              }}
                            />
                          }
                          label="Owner"
                        />
                      </FormGroup>
                    </div>
                  )}

                  {store.isUserOwner && (
                    <div
                      className={
                        adminEnabled || (store.isUserOwner && ownerEnabled)
                          ? styles.ViewToggleDis
                          : styles.ViewToggle
                      }
                    >
                      <div className={styles.ViewToggleHead1}>
                        Dashboard viewer
                        <Checkbox
                          checked={isViewAdmin || adminEnabled}
                          onChange={(event) => {
                            if (
                              !ownerEnabled ||
                              (store.isUserAdmin &&
                                !adminEnabled &&
                                !isViewAdmin)
                            ) {
                              setIsViewAdmin(event.target.checked);
                            }
                          }}
                        />
                      </div>
                      <div className={styles.ViewToggleBody1}>
                        <span className={styles.ViewToggleNote}>Note: </span>
                        Viewers only see CUPI Web Dashboard usage
                      </div>
                    </div>
                  )}
                  {store.isUserOwner &&
                    companyStore.userType == "PineLabUser" &&
                    userEnabled &&
                    !companyStore.UserHasWallet && (
                      <div className={styles.ViewNote}>
                        <div className={styles.ViewNoteText}>
                          {companyStore?.userKycInfo?.kyc_initiate_on
                            ? "Can not edit until User KYC is completed. Please check User section for KYC Status."
                            : "To add as an App user, KYC needs to be completed. The KYC link will be sent to the User."}
                        </div>
                      </div>
                    )}
                </div>
              </div>
              {isUpdated && successMessage && (
                <div className={removeOwner ? styles.CompletedOwnerRem : styles.Completed}>
                  <img
                    className={styles.Completedicon}
                    alt=""
                    src={removeOwner ? "/x-circle.svg" : "/check-circle.svg"}
                  />
                  <div className={removeOwner ? styles.CompletedownRemText : styles.CompletedText}>{successMessage}</div>
                </div>
              )}
              {errormsg.somethingWentWrong && (
                <div className={styles.Failed}>
                  <div className={styles.FailedText}>{ErrorMessage}</div>
                </div>
              )}

              {errormsg.somethingWentWrong && (
                <div className={styles.Failed}>
                  <div className={styles.FailedText}>{ErrorMessage}</div>
                </div>
              )}

              {companyStore.userType == "PineLabUser" &&
                store?.userKycInfo?.initiate_kyc_bp_response?.kycLink
                  ?.webLink &&
                store.userKycInfo?.initiate_kyc_bp_response?.status ==
                "kyc_initiated" &&
                !store?.UserHasWallet && (
                  <div className={styles.CopyLinkContainer}>
                    <div className={styles.CopyLinkHeader}>
                      <span className={styles.CopyLinkHeaderBold}>Note:</span>
                      Please Copy and share this link with the user to restart
                      KYC.
                    </div>
                    <div className={styles.CopyLinkbody}>
                      <img
                        className={styles.CopyLinkImg}
                        alt=""
                        src="/link.svg"
                      />

                      <div className={styles.CopyLinklink}>
                        {store?.userKycInfo?.initiate_kyc_bp_response?.kycLink?.webLink?.substring(
                          0,
                          23,
                        ) + " "}
                        ...
                      </div>

                      {!copied ? (
                        <button
                          className={styles.CopyLinkBtn}
                          onClick={() => {
                            copyToClipboard(
                              store?.userKycInfo?.initiate_kyc_bp_response
                                ?.kycLink?.webLink,
                            );
                          }}
                        >
                          <img
                            className={styles.CopyLinkBtnimg}
                            alt=""
                            src="/copyIcon.svg"
                          />
                          Copy
                        </button>
                      ) : (
                        <div className={styles.CopyLinkBtn2}>Copied</div>
                      )}
                    </div>
                  </div>
                )}
              {((!adminEnabled && !isViewAdmin) ||
                store.isUserOwner ||
                store.isUserAdmin) &&
                !store.isUserGlobalViewAdmin &&
                !store.isUserViewAdmin && (
                  <div
                    className={styles.loadsButtons}
                    onClick={() => {
                      onFrameButtonClick();
                    }}
                  >
                    Submit
                  </div>
                )}

              {/* Owner added success message – appears below Submit */}
              {/* {ownerAddedSuccess && isUpdated && (
                <div className={styles.Completed} style={{ marginTop: "12px" }}>
                  <img
                    className={styles.Completedicon}
                    alt=""
                    src="/check-circle.svg"
                  />
                  <div className={styles.CompletedText}>
                    {store.name} has been added as owner.
                  </div>
                </div>
              )} */}

              {companyStore.userType == "PineLabUser" && (
                <div className={styles.finalCupiLogo}>
                  <img
                    className={styles.escrowLogo}
                    alt=""
                    src="/PineLabsLogo.svg"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {ShowOwnerPopUp && (
          <div className={styles.OwnerpopupOverlay}>
            <div className={styles.OwnerpopupContainer}>
              <div className={styles.OwnerpopupHeading}>
                <img
                  className={styles.OwnerpopupLogo}
                  alt=""
                  src={
                    add_remove_owner
                      ? "/Add-alert-Icon.svg"
                      : "/Remove-alert-Icon.svg"
                  }
                />{" "}
                {add_remove_owner ? "Add as Owner" : "Remove Owner"}
              </div>
              <div className={styles.OwnerpopupSubHeading}>
                {add_remove_owner
                  ? `Are you sure you want to add "${store.name}" as Owner?`
                  : `Are you sure you want to remove "${store.name}" as Owner?`}
              </div>
              <div className={styles.OwnerpopupDiffLine}></div>
              <div className={styles.OwnerpopupContent}>
                {add_remove_owner
                  ? (<>
                    <div className={styles.MarginBottom}>1. This user will get all ownership rights.</div>
                    <div>2. They can add or remove Owner, Admin or User.</div>
                  </>)
                  : (<>
                    <div className={styles.MarginBottom}>1. The user will lose all ownership rights and privileges.</div>
                    <div>2. Past activities will not be affected.</div>
                  </>)}
              </div>
              <div className={styles.OwnerpopupButton}>
                <div
                  className={styles.OwnerpopupCancelBtn}
                  onClick={() => {
                    setShowOwnerPopUp(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  className={styles.OwnerpopupApplyBtn}
                  onClick={() => {
                    setShowOwnerPopUpConfirm(true);
                    if (add_remove_owner) {
                      setOwnerEnabled(add_remove_owner);
                      setAdminEnabled(add_remove_owner);
                      setIsViewAdmin(add_remove_owner);
                    } else {
                      setOwnerEnabled(add_remove_owner);
                    }
                    setShowOwnerPopUp(false);
                  }}
                >
                  {add_remove_owner ? `Add As Owner` : `Remove as Owner`}
                </div>
              </div>

            </div>
          </div>
        )}
      </>
    );
  },
);

EditUserLimits.propTypes = {
  className: PropTypes.string,
};

export default EditUserLimits;
